import { Progeny } from './progeny';

export default Progeny;
